/** Запись, которую человек только что отправил и которую сервер ещё считает. */
export interface PendingEntry {
  id: string;
  text: string;
  date: string;
  stage: 'parsing' | 'searching' | 'failed';
}

/**
 * Подписи стадий разбора.
 *
 * Сервер не шлёт события о ходе работы, поэтому стадии переключаются по
 * времени. Названия выбраны под то, что действительно происходит: сначала
 * фразу разбирает модель, потом каждая позиция ищется в базе продуктов.
 */
export const STAGE_LABELS: Record<PendingEntry['stage'], string> = {
  parsing: 'Разбираю',
  searching: 'Ищу продукты',
  failed: 'Не получилось',
};

/** Через сколько показывать вторую стадию - примерно столько занимает разбор. */
export const SEARCH_STAGE_AFTER_MS = 1600;
